import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";
import { OmsTriggerKey } from "../oms-trigger-key";

export const AutomationRunFlowOutcome = createEnum([
  "completed",
  "exited",
  "error",
]);
export type AutomationRunFlowOutcome = z.infer<typeof AutomationRunFlowOutcome>;

const AutomationRunStepSchema_ = z.object({
  stepId: z.string(),
  passed: z.boolean().optional(),
});
export interface AutomationRunStep extends z.infer<
  typeof AutomationRunStepSchema_
> {}
const AutomationRunStepSchema: z.ZodType<AutomationRunStep> =
  AutomationRunStepSchema_;

const AutomationRunFlowSchema_ = z.object({
  flowId: z.string(),
  versionGroupId: z.string(),
  name: z.string(),
  outcome: AutomationRunFlowOutcome,
  error: z.string().optional(),
  steps: z.array(AutomationRunStepSchema),
});
export interface AutomationRunFlow extends z.infer<
  typeof AutomationRunFlowSchema_
> {}
export const AutomationRunFlowSchema: z.ZodType<AutomationRunFlow> =
  AutomationRunFlowSchema_;

const FulfillmentGroupAutomationRunSchema_ = z.object({
  id: z.string(),
  runId: z.string(),
  fulfillmentGroupId: z.string(),
  triggerKey: z.enum(OmsTriggerKey),
  flows: z.array(AutomationRunFlowSchema),
  ranAt: z.date(),
});
export interface FulfillmentGroupAutomationRun extends z.infer<
  typeof FulfillmentGroupAutomationRunSchema_
> {}
export const FulfillmentGroupAutomationRunSchema: z.ZodType<FulfillmentGroupAutomationRun> =
  FulfillmentGroupAutomationRunSchema_;
